// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"89e79da3","46":"e0196483","193":"8f4c4d04","216":"5d46bf8c","475":"dcf7bb1a","669":"07fcc093","773":"6a3c68c3","888":"0e43f8a9","925":"4f2fe926","986":"1bb62644"}[chunkId] + ".chunk.js";
};